<template>
  <div>
    <div style="margin-top: 15px;">
      <el-table
        ref="multipleTable"
        :data="tableData"
        @current-change="handleCurrentChange"
        style="width: 100%"
        element-loading-text="数据正在加载中"
        :header-cell-style="headClass"
        :row-style="rowClass"
      >
        <!-- <el-table-column type="selection" width="60"></el-table-column> -->
        <el-table-column prop="sn" label="设备序列号"></el-table-column>
        <el-table-column prop="filterStatus" label="15天用水(ml)">
          <template slot-scope="scope">
            <span>{{scope.row.cumulativeVolume2-scope.row.cumulativeVolume1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="代理商"></el-table-column>
        <el-table-column prop="endUserNickname" label="用户"></el-table-column>
        <el-table-column label="联系方式">
          <template slot-scope="scope">
            <div>
              <span>{{usernameToPhone(scope.row.endUsername)}}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="更多">
          <template slot-scope="scope">
            <button @click="openDialogVisible(scope.row)">详情</button>
          </template>
        </el-table-column>-->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <button @click="addWorkOrder(scope.row)">生成工单</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align:right;margin-top: 15px;margin-bottom: 55px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog width="30%" :visible.sync="dialogVisible" title="滤芯状态" :before-close="handleClose">
      <!-- 滤芯状态 -->
      <!-- <el-card style="grid-row: 1;grid-column: 1;"> -->
      <!-- <div slot="header" class="clearfix">
          <span>滤芯状态</span>
      </div>-->
      <div v-for="(filter,index) in filters" style="margin-bottom:15px">
        <el-row>
          <el-col :span="20">
            <span>{{filter.name }}</span>
            <span style="margin-left:10px">{{filter.remainingtime+"/"+filter.endtime+"天"}}</span>
            <el-progress
              :text-inside="true"
              :stroke-width="20"
              :percentage="parseInt(filter.remainingtime*100/filter.endtime)"
              style="margin-top:10px;"
            ></el-progress>
          </el-col>
          <!-- <el-col :span="4">
                            <el-button
                                       style="background: #FFFFFF;border: 1px solid #16ACF0;opacity: 1;border-radius: 33px;align: center;line-height: 0px;margin-left:10px;margin-top:25px"
                                       @click="resetFilter(index+7)">
                                复位</el-button>
          </el-col>-->
        </el-row>
      </div>
      <!-- </el-card> -->
    </el-dialog>

    <work-form
      ref="form"
      :dialogShow="dialogShow"
      :model="mdl"
      :loading="workOrderLoading"
      @cancel="handleCancel"
      @submit="handleOk"
    />
  </div>
</template>

<script>
import { request } from '@/utils/request'
import axios from 'axios'
import workForm from '../../components/workForm/workForm'

export default {
  name: 'filterAlarm',
  components: {
    workForm
  },
  data () {
    return {
      tableData: [],
      filters: [],
      condition: {
        sn: '',
        pageId: 1,
        size: 10,
        filterStatus: 1,
      },
      nid: '',
      dialogVisible: false,
      total: 0,
      // detailVisible: false,
      // installLogDetail: {},
      currentPage: 1,
      pageSize: 10,
      waterPurifyInfo: {},
      dialogShow: false,
      workOrderLoading: false,
      mdl: null,
      edit: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    handleSizeChange (val) {
      this.condition.size = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.condition.pageId = val
      this.getTableData()
    },
    headClass ({ row, rowIndex }) {
      if (rowIndex == 0) {
        return ''
      }
      return ''
    },
    rowClass ({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'background:#F1F2F7;'
      } else {
        return 'background:white;'
      }
      return ''
    },
    getTableData () {
      var thiz = this
      const loading = this.$loading({
        lock: true,
        text: '获取表格数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      setTimeout(() => {
        loading.close()
      }, 3000)
      axios
        .get(this.$store.getters.getApiValue + '/srsDevice/listLongTimeNoUseAlarm.do', {
          params: this.condition,
        })
        .then(function (response) {
          loading.close()
          var data = response.data
          if (data.status == '200') {
            thiz.total = data.totalCount
            thiz.tableData = data.data
          } else {
            thiz.$message.error(data.message)
          }
        })
        .catch(function (error) {
          loading.close()
          thiz.$message.error('系统异常，请与管理员联系!')
          console.log(error)
        })
    },

    openDialogVisible (row) {
      this.dialogVisible = true
      this.nid = row.nid
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleClose () {
      this.dialogVisible = false
      this.filters = []
    },

    usernameToPhone (username) {
      if (username) {
        let index = username.indexOf('_') + 1
        return username.substr(index, username.length)
      }
      return ''
    },

    // 创建工单
    addWorkOrder (row) {
      this.dialogShow = true
      this.edit = false
      row['typeCode'] = '维保'
      row['matterCategory'] = 2
      this.mdl = row
      console.log('row', row)
    },

    handleOk (isPass, values, edit) {
      var thiz = this;
      this.workOrderLoading = true
      if (isPass) {
        // 新增
        var param = values
        if (!edit) {
          // param['fbid'] = 0
          // param['nid'] = this.nid
          console.log('上传数据', values)
          new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 1000)
          }).then(res => {
            var url = '/maintain/addTicket.do';
            axios.get(this.$store.getters.getApiValue + url, {
              params: param
            }).then(function (response) {
              var data = response.data;
              if (data.status == "200") {
                thiz.$message.success('新增成功!');
                thiz.getTableData();
                thiz.dialogShow = false
              } else {
                thiz.$message.error(data.message);
              }
            }).catch(function (error) {
              console.log(error);
              thiz.$message.error("系统异常!请与管理员联系!");
            }).finally(() => {
              thiz.workOrderLoading = false
            });
          })
        } else {
          // param['fbid'] = 1

        }
      } else {
        console.log('submit error')
        this.$message.error("填写不完整或格式不正确，请确认！")
        this.workOrderLoading = false
      }
    },


    handleCancel () {
      this.dialogShow = false
    }

  },
}
</script>

<style scoped>
.detail-image {
  width: 120px;
  height: 120px;
}
</style>
